import { useEffect, useMemo } from "react";
import {
  CharacterLetter,
  CharacterResult,
} from "common/character/dto/CharacterResult";
import { CharacterNav } from "./style/CharacterRelateContainNav.style";
import { useCharacterByLetter } from "hooks/asocijator/character/useCharacterByLetter";
import { getCharacterLetter } from "common/character/character_common";
import CharacterImage from "../../file/CharacterImage";

type CharacterRelateContainNavCharProps = {
  navCharacterLetter: CharacterLetter;
  navCharacterHandle: (navChar: CharacterResult | null) => void;
  navCharacterActive?: boolean;
};

const CharacterRelateContainNavChar = ({
  navCharacterLetter,
  navCharacterHandle,
  navCharacterActive,
}: CharacterRelateContainNavCharProps) => {
  const { character, refetch } = useCharacterByLetter(
    navCharacterLetter.letter,
    false
  );
  const isLetterGiven = useMemo(
    () => typeof navCharacterLetter.signImage === "undefined",
    [navCharacterLetter.signImage]
  );
  const navLetter = useMemo(
    () => getCharacterLetter(navCharacterLetter, true),
    [navCharacterLetter]
  );

  const navCharacterClickHandle = () => {
    if (!navCharacterActive) {
      if (!character) {
        refetch();
      } else {
        navCharacterHandle(character);
      }
    } else {
      navCharacterHandle(null);
    }
  };

  useEffect(() => {
    if (character) {
      navCharacterHandle(character);
    }
  }, [character]);

  useEffect(() => {
    // console.log(
    //   "getCharacterLetter(navCharacterLetter)",
    //   getCharacterLetter(navCharacterLetter)
    // );
  }, [navCharacterLetter]);

  return (
    <CharacterNav onClick={navCharacterClickHandle} active={navCharacterActive}>
      {isLetterGiven && navLetter}
      {!isLetterGiven && (
        <CharacterImage characterFile={{ path: navLetter }} small />
      )}
    </CharacterNav>
  );
};

export default CharacterRelateContainNavChar;
